import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { BOOK_MOCKUP_DARK, CHECKOUT_URL, heroHighlights } from '../data/landing';
export function Hero() {
  return <section id="inicio" className="bg-ink" data-id="element-87" data-mp="9ka2cotbuas6">
      <div className="mx-auto flex max-w-4xl flex-col items-center px-5 pb-8 pt-4 text-center md:px-6 md:pb-14 md:pt-10" data-id="element-88" data-mp="9l33995lu62e">
        <h1 className="font-display text-[1.3rem] leading-[1.22] text-cream md:text-3xl lg:text-[2.5rem] lg:leading-[1.15]" data-id="element-89" data-mp="129h37ug97cgl">
          Desbloquea una conciencia superior y un profundo poder interior{' '}
          <span className="text-gold" data-id="element-90" data-mp="sbb1pdyd08c9">oculto en tu interior.</span>
        </h1>

        {/* Recorte ajustado al libro para eliminar el espacio vacío de la imagen */}
        <div className="relative mt-3 aspect-[600/900] w-[200px] overflow-hidden md:mt-5 md:w-[270px]" data-id="element-91" data-mp="nbyh6zuyndcu">
          <img src={BOOK_MOCKUP_DARK} alt="Mockup del libro El Libro del Despertar, Volumen 1: un ojo dorado rodeado de círculos sobre un cielo cósmico" className="absolute left-[-27.5%] top-[-16%] h-auto w-[149.3%] max-w-none" data-id="element-92" data-mp="3d2tm12xxw8bd" />
        </div>

        <p className="mt-1 text-[10px] uppercase tracking-[0.2em] text-muted md:text-xs" data-id="element-93" data-mp="3o6u87dib4xei">
          Edición digital en español · PDF
        </p>

        <div className="mt-4 flex w-full flex-col items-center gap-2 md:mt-6" data-id="element-94" data-mp="3e961dp7ffzfz">
          <CtaButton href={CHECKOUT_URL} className="w-full sm:w-auto" data-id="element-95" data-mp="3eb8x8pv9gmsm">
            Quiero el libro ahora
          </CtaButton>
          <p className="font-serif text-sm italic text-gold-light md:text-base" data-id="element-96" data-mp="3599ki9ra44vh">
            Tu recorrido comienza aquí.
          </p>
        </div>

        <p className="mt-5 max-w-2xl font-serif text-base leading-relaxed text-cream/85 md:mt-7 md:text-xl" data-id="element-97" data-mp="2qlofgaaufvkx">
          Explora la conciencia, la percepción, el poder de la mente y los
          símbolos ancestrales que han acompañado al pensamiento humano durante
          siglos.
        </p>
        <p className="mt-2 max-w-2xl text-[13px] leading-relaxed text-muted md:mt-3 md:text-base" data-id="element-98" data-mp="2ljz38rbvxbv9">
          Un libro digital para quienes desean ir más allá de lo evidente,
          cuestionar sus creencias y descubrir nuevas conexiones entre el
          pensamiento, la espiritualidad y la realidad.
        </p>

        <ul className="mt-5 grid w-full gap-y-2 border-t border-line pt-4 text-left text-[13px] text-cream/80 sm:flex sm:flex-wrap sm:justify-center sm:gap-x-8 sm:gap-y-3 sm:text-center md:mt-8 md:pt-6 md:text-sm" data-id="element-99" data-mp="ia5f4mct1xow">
          {heroHighlights.map(item => <li key={item} className="flex items-center gap-2" data-id="element-100" data-mp="16346au4azydj">
              <CheckIcon aria-hidden="true" className="h-4 w-4 shrink-0 text-gold" data-id="element-101" data-mp="112g5jgq9w364" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}